/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  function singleEntryTitle() {
    //allow caption to sit half way on bottom edge of promos while keeping their ratio. Purely cosmetic
    $('article.hentry .entry-title').each(function() {
      var captionHeight = ($(this).outerHeight());
      var captionOffset = -(captionHeight / 2);
      $(this).css("margin-top", captionOffset);
    });
  }


  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

        /****************
        **  Primary Navigation - overlay settings
        *****************/
        $('#banner-wrap').on('shown.bs.collapse', function () {
          $('body').addClass('primary-nav-engaged');
        });
        $('#banner-wrap').on('show.bs.collapse', function () {
          $('body').addClass('primary-nav-engaging');
        });
        $('#banner-wrap').on('hide.bs.collapse', function () {
          $('body').removeClass('primary-nav-engaged primary-nav-engaging');
        });

        /****************
        **  Match Heights
        *****************/
        $('.article-grid .article-item figure').matchHeight();

        /****************
        **  SVG swap out with PNG on incompatible browsers
        *****************/
        if (!Modernizr.svg) {
          $('img[src*="svg"]').attr('src', function() {
            return $(this).attr('src').replace('.svg', '.png');
          });
        }

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // Beer page
    'beers': {
      init: function() {
        /****************
        **  Match Heights
        *****************/
        $('.beer-grid .beer-link').matchHeight();
        $('.beer-grid figure').matchHeight({byRow: false});
        $('.beer-grid.smaller-grid .beer-link .details').matchHeight({byRow: false});
        $('.beer-grid.smaller-grid .beer-link .details h3').matchHeight({byRow: false});
        $('.beer-grid.smaller-grid .beer-link .details .beer-stats').matchHeight({byRow: false});
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // Single Beer
    'single_beer': {
      init: function() {
        $('#menu-primary-navigation .menu-beer').addClass('active');
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // Events Archive page
    'post_type_archive_tribe_events': {
      init: function() {
        $('.nav-primary ul .menu-item').removeClass('active');
        $('.nav-primary ul .menu-events').addClass('active');
      },
    },
    // Events detail page
    'single_tribe_events': {
      init: function() {
        $('.nav-primary ul .menu-item').removeClass('active');
        $('.nav-primary ul .menu-events').addClass('active');
        singleEntryTitle();
        $(window).resize(function() {
          singleEntryTitle();
        });
      },
    },
    // Events Venue Detail page
    'single_tribe_venue': {
      init: function() {
        $('.nav-primary ul .menu-item').removeClass('active');
        $('.nav-primary ul .menu-events').addClass('active');
      },
    },
    // 404
    'error404': {
      init: function() {
        $('.nav-primary ul .menu-item').removeClass('active');
      },
    },
    // Single Post
    'single_post': {
      init: function() {
        singleEntryTitle();
        $(window).resize(function() {
          singleEntryTitle();
        });
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
